/** Default send delay between two stickers in the mem-party mode */
export const MEME_PARTY_DEFAULT_SEND_DELAY = 3000;

/** Default meme party duration */
export const MEME_PARTY_DEFAULT_DURATION = 75000;
